import { Pipe, PipeTransform } from '@angular/core';
import { TimezoneService } from '../services/timezone.service';

@Pipe({
  name: 'argentinaDateTime',
  pure: true,
})
export class ArgentinaDateTimePipe implements PipeTransform {
  constructor(private timezoneService: TimezoneService) {}

  transform(value: any): string {
    return this.timezoneService.formatToArgentinaDateTime(value);
  }
}